export default __webpack_public_path__ + "static/media/bike2.79f46ecc.png";